export const extractJsonObjects = (str = '') => {
  if (!str || typeof str !== 'string') return [];
  const regex = /{[^{}]*}/g;
  const matches = str.match(regex);
  if (!matches) return [];

  return matches
    .map((match) => {
      try {
        return JSON.parse(match);
      } catch (e) {
        return null;
      }
    })
    .filter(Boolean);
};
